/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Col, Row, Alert } from 'react-bootstrap';
import { toHeaderCase } from 'js-convert-case';

export interface IStatusCompProps {
  statusComp: {
    statusType?: 'success' | 'danger' | 'warning';
    title?: string;
    description?: string;
  };
}
export const StatusComp = (props: IStatusCompProps) => {
  const { statusType, description, title } = props?.statusComp;

  const _renderDescription = () => {
    if (description) {
      return (
        <p className="fs-6 text-dark mb-0 w-100 align-justify">{description}</p>
      );
    }
    return null;
  };

  const _renderTitleIf = () => {
    if (title) {
      return (
        <p style={{ fontSize: '13px', fontWeight: 'bold' }} className="m-0">
          {title ?? ''}
        </p>
      );
    }
  };

  return (
    <Row style={{ paddingLeft: '0.3%', paddingTop: '2.3%' }}>
      <Col xs="auto" className="px-3">
        <Alert variant={statusType} className="py-1 px-2 w-100 rounded-pill">
          {_renderTitleIf()}
          {_renderDescription()}
        </Alert>
      </Col>
    </Row>
  );
};

StatusComp.defaultProps = {
  statusType: 'success',
  title: 'Status Title',
  description: 'Status Description',
};
